module.exports = __webpack_public_path__ + "img/icon-12.37439d01.png";